// NPM Imports
import React from "react";
import { Button } from "@revvsales/components";
import Modal from "react-responsive-modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import uuid from "react-native-uuid";
import { connect } from "react-redux";

// Action Imports
// import { event } from "jquery";
import QuotationActions from "../../actions/QuotationActions";
import {
  updateHoveredDocumentSectionId,
  updateDocumentClickedComponentID,
  removeDisabledStripeButtonfromDoc,
} from "../../actions/DocumentActions";
import { updateToolpaneView } from "../../actions/ToolbarActions/toolbarActions";
import { removeDisabledStripeButtonfromTemplate } from "../../actions/DocumentTemplateActions/templateActions";

// Destructuring
const {
  setSectionDataForActivePaymentButtonInRightToolPane,
} = QuotationActions;

class StripeButtonRemovePopup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  _onClose = event => {
    console.debug(this.props.buttonData);
    event.preventDefault();
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
    this.props.updateDocumentClickedComponentID(
      this.props.buttonData[0].content.id,
      false,
      this.props.buttonData[0].content.type,
    );
    this.props.setSectionDataForActivePaymentButtonInRightToolPane(
      this.props.buttonData[0].content,
    );
    this.props.updateHoveredDocumentSectionId(
      this.props.buttonData[0].content.id,
      null,
    );
    this.props.updateToolpaneView(this.props.buttonData[0].content, "DOCUMENT");

    this.props.onClose("stripeButtonRemovePopup", false);
  };

  _removeButton = async () => {
    if (this.props.buttonValue === "forReviewer") {
      this.props.updateMultipleState({
        stripeButtonRemovePopup: false,
        showAddRecipientsPopup: true,
      });
    } else if (this.props.buttonValue === "forApproval") {
      this.props.updateMultipleState({
        stripeButtonRemovePopup: false,
        showAnalysisModal: true,
      });
    } else if (this.props.buttonValue === "forAcceptance") {
      this.setState({ approvalEventUuid: uuid.v4() }, () =>
        this.props
          .analyzeDoc({
            event_id: this.state.approvalEventUuid,
            entity: "DEAL",
            entity_id: this.props.docID,
          })
          .then(response => {
            const { Analysis } = response;
            // Check if there is no approval required then, show the "Signer list"
            if (Analysis && Analysis.length === 0) {
              // if form field is empty : show sendConfirmationPopup
              if (this.props.checkFormFields()) {
                this.props.updateMultipleState({
                  stripeButtonRemovePopup: false,
                  showAnalysisModal: false,
                  addAcceptorList: true,
                });
              } else {
                this.props.updateMultipleState({
                  stripeButtonRemovePopup: false,
                  showAnalysisModal: false,
                  showSendConfirmationPopup: true,
                });
              }
            } else {
              this.props.updateMultipleState({
                stripeButtonRemovePopup: false,
                showAnalysisModal: true,
              });
            }
          }),
      );
    } else if (this.props.buttonValue === "eSign") {
      if (
        this.props.fetchSignersList &&
        this.props.fetchSignersList.length > 0
      ) {
        const signersList = this.props.fetchSignersList;
        let status = true;
        if (Array.isArray(signersList) && signersList.length > 0) {
          status = signersList.every(
            v =>
              v.signer_email !== "" &&
              v.first_name !== "" &&
              v.last_name !== "",
          );
        } else {
          status = false;
        }
        if (status) {
          this.props.updateMultipleState({
            approvalEventUuid: uuid.v4(),
          });
          this.setState({ approvalEventUuid: uuid.v4() }, () =>
            this.props
              .analyzeDoc({
                event_id: this.state.approvalEventUuid,
                entity: "DEAL",
                entity_id: this.props.docID,
              })
              .then(response => {
                const { Analysis } = response;
                // Check if there is no approval required then, show the "Signer list"
                if (Analysis && Analysis.length === 0) {
                  if (this.props.checkFormFields()) {
                    this.props.updateMultipleState({
                      stripeButtonRemovePopup: false,
                      showAnalysisModal: false,
                      showSignerListPopup: true,
                    });
                  } else {
                    this.props.updateMultipleState({
                      stripeButtonRemovePopup: false,
                      showAnalysisModal: false,
                      showSendConfirmationPopup: true,
                    });
                  }
                } else {
                  this.props.updateMultipleState({
                    stripeButtonRemovePopup: false,
                    showAnalysisModal: true,
                  });
                }
              }),
          );
        } else {
          this.props.updateMultipleState({
            stripeButtonRemovePopup: false,
            showEmptySignerPopup: true,
          });
        }
      } else {
        this.props.updateMultipleState({
          stripeButtonRemovePopup: false,
          showEmptySignerPopup: true,
        });
      }
    } else if (this.props.buttonValue === "templatePublish") {
      this.props.onClose("stripeButtonRemovePopup", false);
      this.props.onClose("showPublishTemplatePopup", true);
    } else if (this.props.buttonValue === "stripePayment") {
      this.props.updateMultipleState({
        buttonValue: null,
      });
    }

    // To filter out id of all the stripe buttons
    const stripeData = Object.values(this.props.components)
      .filter(elem => elem.content.type === "StripePayment")
      .map(obj => obj.content.id);

    const stripeRemovalData = {
      component_id: stripeData,
      field_ids: {
        deleted: [],
      },
    };

    if (this.props.buttonValue !== "templatePublish") {
      await this.props.removeDisabledStripeButtonfromDoc(
        stripeRemovalData,
        this.props.docNo,
      );
    } else {
      await this.props.removeDisabledStripeButtonfromTemplate(
        stripeRemovalData,
        this.props.templateID,
      );
    }
  };

  _popupClose = () => {
    console.debug(this.props);
    this.props.onClose("stripeButtonRemovePopup", false);
  };

  render() {
    return (
      <div>
        <Modal
          open
          onClose={this._popupClose}
          center
          closeOnOverlayClick={false}>
          <div className="inviteteammatespopup-wrapper">
            <div className="inviteteammatespopup-modal-heading popup-title">
              <span>
                <FontAwesomeIcon
                  className="exclamation-triangle"
                  icon={["fas", "exclamation-triangle"]}
                />{" "}
              </span>
              <span>You have not added amount in Payment button</span>
            </div>
          </div>
          <div className="popup-title">
            Payment buttons without any configured amount will be removed when
            you share documents.
          </div>
          <div className="popup-title title-margin">
            Configure the payment button in 3 easy steps
          </div>
          <div className="stripe-description-section">
            <ol>
              <li className="stripe-description-text">
                Click on the Payment button block
              </li>
              <li className="stripe-description-text">
                Integrate with Stripe, if you {"haven't"} already
              </li>
              <li className="stripe-description-text">
                Enter amount to be paid
              </li>
            </ol>
          </div>
          <div className="createquotepopup-footer popup-footer">
            <div className="footer-actions">
              <Button
                data-test="stripe-modal-go-back"
                onClick={this._onClose}
                className={
                  this.props.buttonValue === "stripePayment"
                    ? "btn btn-primary"
                    : "btn btn-transparent createquotepopup-footer-cancelbtn"
                }>
                {this.props.templateId
                  ? "Back to template"
                  : "Back to document"}
              </Button>
              {this.props.buttonValue !== "stripePayment" ? (
                <Button
                  onClick={this._removeButton}
                  data-test="stripe-modal-go-ahead"
                  className="btn btn-primary">
                  Remove & continue
                </Button>
              ) : null}
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

// const mapStateToProps = {};

const mapDispatchToProps = {
  setSectionDataForActivePaymentButtonInRightToolPane,
  updateHoveredDocumentSectionId,
  updateToolpaneView,
  updateDocumentClickedComponentID,
  removeDisabledStripeButtonfromDoc,
  removeDisabledStripeButtonfromTemplate,
};

export default connect(
  null,
  mapDispatchToProps,
)(StripeButtonRemovePopup);



// WEBPACK FOOTER //
// ./src/components/DocumentApprovalPopupNew/StripeButtonRemovePopup.js